import { useMainStore } from '@/store/index'
import { ref } from 'vue'

export function useBlogPosts(blogName) {
  const store = useMainStore()

  const blog = ref(null)
  const posts = ref([])
  const categories = ref([])

  async function loadPosts() {
    try {
      // Fetch categories using exact provided API
      categories.value = await $fetch(
        `${store.baseURL}/get_model_categories?model_type=Blog`
      )
      // Categories API returns array? (make sure it's correct)
      if (!Array.isArray(categories.value)) {
        console.warn('Categories API did not return an array, got:', categories.value)
        categories.value = []
      }

      // Fetch blogs using exact provided API
      const blogs = await $fetch(`${store.baseURL}/blogs`)

      // Find blog by name (case insensitive)
      blog.value = blogs.find(
        (b) => b.name.toLowerCase() === blogName.toLowerCase()
      )

      if (!blog.value) {
        console.warn(`Blog "${blogName}" not found.`)
        posts.value = []
        return
      }

      // Map each post to include category details by matching category IDs
      posts.value = (blog.value.posts || []).map((post) => {
        // post.category_ids is an array of category IDs
        const postCategories = (post.categories || [])
          .map((id) => categories.value.find((cat) => cat.id === id))
          .filter(Boolean)

        return {
          ...post,
          categories: postCategories,
        }
      })
    } catch (error) {
      console.error('Failed to load blog posts:', error)
    }
  }

  function getPostBySlug(slug) {
    return posts.value.find((post) => post.slug === slug)
  }

  return {
    blog,
    posts,
    categories,
    loadPosts,
    getPostBySlug,
  }
}

